import React, { useContext } from "react";
import {
  RewardsAccountSelection as AccountSelection,
  useDeviceTypes,
} from "halifax";

import { RewardsAccountSelectionConnectorProps } from "./container";
import { INELIGIBLE_REWARDS_REDEMPTION_NOTICE } from "./constants";
import {
  getExperimentVariant,
  useExperiments,
  XMOD_V1_EXPERIMENT,
} from "../../../../context/experiments";
import { AVAILABLE } from "@capone/experiments";
import { ClientContext } from "../../../../App";

export interface IRewardsAccountSelectionProps
  extends RewardsAccountSelectionConnectorProps {
  className?: string;
  popoverClassName?: string;
}

export const RewardsAccountSelection = (
  props: IRewardsAccountSelectionProps
) => {
  const {
    className,
    rewardsAccounts,
    selectedAccountReferenceId,
    fetchRewardsAccounts,
    setSelectedAccountReferenceId,
    popoverClassName,
  } = props;
  const { matchesMobile } = useDeviceTypes();
  const { sessionInfo } = useContext(ClientContext);

  const expState = useExperiments();

  const isXmodRedesign =
    getExperimentVariant(expState.experiments, XMOD_V1_EXPERIMENT) ===
    AVAILABLE;

  React.useEffect(() => {
    fetchRewardsAccounts(false, sessionInfo);
    let accountId = localStorage.getItem("referenceId");
    if (accountId !== selectedAccountReferenceId) {
      setSelectedAccountReferenceId(accountId);
    }
  }, [sessionInfo]);

  const onSelectedRewardsAccount = (accountId: string | null) => {
    localStorage.setItem("referenceId", accountId ?? "");
  };

  const selectedAccount = React.useMemo(
    () =>
      rewardsAccounts.find(
        (account) => account.accountReferenceId === selectedAccountReferenceId
      ),
    [rewardsAccounts, selectedAccountReferenceId]
  );

  return (
    <AccountSelection
      className={className}
      selectedAccountReferenceId={selectedAccountReferenceId}
      setSelectedAccountReferenceId={(accountId) => {
        setSelectedAccountReferenceId(accountId);
        onSelectedRewardsAccount(accountId);
      }}
      rewardsAccounts={rewardsAccounts}
      isMobile={matchesMobile}
      popoverClassName={popoverClassName}
      texts={{
        hiddenRewardsText: INELIGIBLE_REWARDS_REDEMPTION_NOTICE(
          selectedAccount?.customerAccountRole
        ),
      }}
      isXmodRedesign={isXmodRedesign}
    />
  );
};
